
<div>
  <EditableArea
    v-if="content.menuNavigation"
    :class="[content.classeCssConteneur]"
    :content="content.menuNavigation"
    :parentTemplateId="metadata['mgnl:template']"
  >
  </EditableArea>
</div>
